module.exports = __webpack_public_path__ + "img/img2.7d1421b9.jpg";